import React, { useState, useEffect } from 'react';
import { NavLink, useParams } from 'react-router-dom';

import ImageSkeleton from '../../components/Skeleton/ImageSkeleton';
import TextSkeleton from '../../components/Skeleton/TextSkeleton';
import ListSkeleton from '../../components/Skeleton/ListSkeleton';

import IcoCheck from '../../assets/images/check.svg';

import { getIndustriaBySlug } from '../../config/services/strapi/strapi';

import { Industria, Solucion } from '../../interfaces/types';

import classNames from 'classnames';

function DetalleIndustria() {
  const [cargando, setCargando] = useState<boolean>(true);
  const [industria, setIndustria] = useState<Industria | null>(null);

  const { slug: slugIndustria } = useParams<{ slug: string }>();

  useEffect(() => {
    const fetchIndustria = async () => {
      setCargando(true);

      const rawIndustria = await getIndustriaBySlug(slugIndustria || '');
      const slug = `/industria/${rawIndustria.slug}`;
      const beneficios = rawIndustria.beneficios[0]?.children || [];
      const soluciones: Solucion[] = rawIndustria.soluciones_energeticas.map((solucion: any) => ({
        id: solucion.id,
        externo: solucion.externo,
        nombre: solucion.nombre,
        portada: solucion.portada,
        imagenIndustria: solucion.imagen_industria,
        url: solucion.url,
      }));

      console.log(soluciones[0]);

      setIndustria({
        id: rawIndustria.id,
        nombre: rawIndustria.nombre,
        nombreIndustria: rawIndustria.nombre_industria,
        icono: rawIndustria.icono,
        logo: rawIndustria.logo,
        descripcion: rawIndustria.descripcion,
        beneficios: beneficios,
        slug: slug,
        banner: rawIndustria.banner,
        imagenBeneficios: rawIndustria.imagen_beneficios,
        soluciones: soluciones,
        experiencia: rawIndustria.experiencia || []
      });
      setCargando(false);

      document.title = `${rawIndustria.titulo_pestana} | Gasco Soluciones Energéticas`;
    };

    setIndustria(null);

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    fetchIndustria();
  }, [slugIndustria]);

  return (
    <main>
      {/* Hero */}
      <section className='w-full relative'>
        {
          cargando ?

            <div className='w-full h-full relative'>
              <ImageSkeleton className="w-full !h-[300px] lg:!h-[424.5px]" />
              <div className='absolute inset-0 left-0 top-0 w-full h-full bg-black opacity-30'></div>
            </div>

            :

            <>
              <div className='absolute left-[15px] md:left-10 lg:left-36 h-full flex flex-col justify-center'>
                <h1 className='!text-white !text-[25.5px] lg:!text-[34px] 2xl:!text-[48px] !font-[600] leading-[30.6px] 2xl:!leading-[57px]'>{industria?.nombre || 'Cargando...'}</h1>
                <NavLink
                  to="/contacto"
                  className='!text-white !text-[11.9px] 2xl:!text-[16.8px] !font-[400] leading-[17.85px] 2xl:!leading-[28.8px] !bg-[var(--background-color-primary)] flex justify-center items-center !mt-[17px] px-[18px] 2xl:px-[22.82px] py-[11.05px] 2xl:py-[14px] border-[1px] border-[var(--border-color-secondary)] rounded-lg'
                >
                  Contacta a un especialista
                </NavLink>
              </div>
              <figure className='w-full h-auto !m-0 !h-[300px] lg:!h-[424.5px] xl:!h-[500px] 2xl:!h-[600px]'>
                <img src={industria?.banner?.url} className='w-full h-full object-cover' alt="" />
              </figure>
            </>
        }
      </section>
      {/* Descripción */}
      <section className='px-[15px] md:px-10 lg:px-36 pb-20'>
        <div className='flex flex-col md:flex-row md:flex-row-reverse md:items-center md:gap-12 2xl:gap-44'>
          <div className="w-full">
            {
              industria?.logo && <div className="flex justify-center items-center mt-5 mb-5">
                <figure className='w-[136px]'>
                  <img src={industria?.logo?.url} alt={industria?.nombre} />
                </figure>
              </div>
            }
          </div>
          <div className={classNames('md:mt-16', {
            'mt-24': !industria?.logo
          })}>
            <div>
              {
                cargando ?

                  <TextSkeleton className='!w-full !max-w-full !h-[20px] mb-10' />

                  :

                  industria?.descripcion.map((item: any, itemindex: number) => {
                    if (item.type === 'paragraph') {
                      return (
                        <p key={`item-${itemindex}`} className='mb-4'>
                          {
                            item.children.map((child: any, childIndex: number) => {
                              if (child.type === 'text') {
                                return (
                                  <span key={`item-${itemindex}-${childIndex}`} className='!text-[var(--text-color-primary)] !text-[11.9px] 2xl:!text-[16.8px] !leading-[21.42px] 2xl:!leading-[28.8px] !font-[400] lg:px-0 mb-[17px]'>
                                    {child.text}
                                  </span>
                                );
                              }

                              if (child.type === 'link') {
                                return (
                                  <NavLink key={`item-${itemindex}-${childIndex}`}
                                    to={child.url}
                                    className='!text-[var(--text-color-secondary)] !text-[11.9px] 2xl:!text-[16.8px] !leading-[21.42px] 2xl:!leading-[28.8px] !font-[400] lg:px-0 mb-[17px]'
                                  >
                                    {child.children[0]?.text || ''}
                                  </NavLink>
                                );
                              }
                            })
                          }
                        </p>
                      )
                    }

                    else if (item.type === 'list') {
                      return (
                        <ul key={`item-${itemindex}`} className='list-disc pl-5 mb-4 !list-["_-_"] !apearance-none'>
                          {
                            item.children.map((listItem: any, listIndex: number) => (
                              <li key={`item-${itemindex}-${listIndex}`} className='!text-[var(--text-color-primary)] !text-[11.9px] 2xl:!text-[16.8px] !leading-[21.42px] 2xl:!leading-[28.8px] !font-[400]'>
                                <span>{listItem.children[0]?.text || ''}</span>
                              </li>
                            ))
                          }
                        </ul>
                      )
                    }
                  })
              }
            </div>
            <div>
              {Boolean(industria?.experiencia?.length) && <h4 className='!text-[var(--text-color-primary)] !text-[25.5px] !font-[400] !leading-[30.6px] !mb-10'>Experiencia</h4>}
              {
                industria?.experiencia && industria.experiencia.map((item, index) => (
                  <div key={index} className="mb-6">
                    <div className="mb-6">
                      <img src={item.imagen.url} className="w-full !max-w-[100px] h-auto" />
                    </div>
                    <div className="!text-[11.9px] 2xl:!text-[16.8px] !font-[400] !leading-[21.4px] text-[var(--text-color-primary)]">
                      {
                        item.contenido.map((contenido: Record<string, any>, cIndex: number) => {

                          if (contenido.type === 'paragraph') {
                            return (<p className="mb-4" key={`contenido-${cIndex}`}>
                              {
                                contenido.children.map((child: Record<string, any>, childIndex: number) => {
                                  if (child.type === 'text' && !child.bold && !child.italic) {
                                    return <span key={`child-${cIndex}-${childIndex}`} >{child.text}</span>;
                                  }

                                  else if (child.type === 'text' && child.bold) {
                                    return <span key={`child-${cIndex}-${childIndex}`} className="!font-bold">{child.text}</span>;
                                  }

                                  else if (child.type === 'text' && child.italic) {
                                    return <span key={`child-${cIndex}-${childIndex}`} className="!italic">{child.text}</span>;
                                  }

                                  else if (child.type === 'text' && child.bold && child.italic) {
                                    return <span key={`child-${cIndex}-${childIndex}`} className="!font-bold !italic">{child.text}</span>;
                                  }

                                  else return null;
                                })
                              }
                            </p>)
                          }
                          
                        })
                      }
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </section>
      {/* Beneficios */}
      <section className='pb-20'>
        <div className="flex flex-col lg:flex-row lg:items-start lg:gap-16 lg:pr-12">
          {
            cargando ?

              <ImageSkeleton className="w-full !h-[300px] lg:!h-[424.5px] mb-4" />

              :

              <figure className='w-full !m-0 !h-[255px] md:!h-[521px] lg:!h-[490px]'>
                {industria?.imagenBeneficios && <img src={industria?.imagenBeneficios?.url} alt="Beneficios" className='w-full h-full object-cover' />}
              </figure>
          }
          <div className='w-full px-[15px] lg:px-0'>
            <h4 className='!text-[var(--text-color-primary)] !text-[27.2px] 2xl:!text-[48px] !font-[600] !leading-[32.4px] py-[34px] lg:pt-[0px] !my-0'>Te ofrecemos</h4>
            <ul>
              {
                cargando ?

                  <ListSkeleton className='!w-full !max-w-full !h-[20px] mb-4' />

                  :
                  
                  industria?.beneficios.map((beneficio, bIndex) => (
                    <li key={`beneficio-${bIndex}`} className='flex justify-start items-start gap-2 !text-[var(--text-color-primary)] !text-[14.5px] 2xl:!text-[16.8px] 2xl:!text-[20.4px] !leading-[21.42px] 2xl:!leading-[28.8px] !font-[400] mb-2'>
                      <img src={IcoCheck} alt="Check" className='w-[21.25px] h-auto mt-1' />
                      <span>{beneficio?.children ? beneficio?.children[0]?.text : ''}</span>
                    </li>
                  ))
              }
            </ul>
          </div>
        </div>
      </section>
      {/* Soluciones */}
      <section className="px-[15px] lg:px-36 pb-20">
        <div>
          <h4 className='!text-[var(--text-color-primary)] !text-[25.5px] md:!text-[34px] !font-[600] !leading-[32.4px] py-[34px] !my-0'>
            Soluciones Energéticas para la {industria?.nombreIndustria}
          </h4>
          <div className="grid grid-cols-12 gap-4">
            {
              cargando ?

                Array.from({ length: 4 }).map((_, index) => (
                  <ImageSkeleton key={`skeleton-${index}`} className="col-span-12 md:col-span-3 rounded-3xl overflow-hidden w-full h-[520px] md:h-[280px] 2xl:h-[400px] 2xl:h-[620px]" />
                ))

                :

                industria?.soluciones.map((solucion, index) => (
                  <article key={`solucion-${index}`} className='mb-4 col-span-12 md:col-span-3'>
                    {
                      solucion.externo ?

                        <a href={solucion.url} target="_blank" rel="noopener noreferrer" className='relative'>
                          <img src={solucion.imagenIndustria?.url} alt={solucion.nombre} className='w-full h-auto mb-2' />
                          <div className="absolute bottom-[17px] p-[17px]">
                            <h1 className='!text-[18px] 2xl:!text-[26px] 2xl:!text-[28px] !font-[400] !text-white !mb-[17px]'>{solucion.nombre}</h1>
                            <span className='!border-2 !border-white !text-white rounded-full !w-[24px] !max-w-[24px] !h-[24px] !max-h-[24px] flex justify-center items-center'>
                              <i className='fas fa-chevron-right !text-[8.5px]'></i>
                            </span>
                          </div>
                        </a>

                        :

                        <NavLink to={`/soluciones/${solucion.url}`} className='relative'>
                          <img src={solucion.imagenIndustria?.url} alt={solucion.nombre} className='w-full h-auto mb-2' />
                          <div className="absolute bottom-[17px] p-[17px]">
                            <h1 className='!text-[18px] 2xl:!text-[26px] 2xl:!text-[28px] !font-[400] !text-white !mb-[17px]'>{solucion.nombre}</h1>
                            <span className='!border-2 !border-white !text-white rounded-full !w-[24px] 2xl:!w-[30px] !max-w-[24px] 2xl:!max-w-[30px] !h-[24px] 2xl:!h-[30px] !max-h-[24px] 2xl:!max-h-[30px] flex justify-center items-center'>
                              <i className='fas fa-chevron-right !text-[8.5px] 2xl:!text-[12px]'></i>
                            </span>
                          </div>
                        </NavLink>
                    }
                  </article>
                ))
            }
          </div>
        </div>
      </section>
    </main>
  )
}

export default DetalleIndustria